import type { FC, ReactNode } from 'react';
import React from 'react';

import Icon from '../ui/Icon';

interface IReviewSectionProps {
  icon: string;
  title: string;
  onEdit?: () => void;
  complete?: boolean;
  children: ReactNode;
}

const ReviewSection: FC<IReviewSectionProps> = ({
  icon,
  title,
  onEdit,
  complete = true,
  children
}) => {
  return (
    <section className="review-section">
      <header className="review-section-head">
        <div className="review-section-heading">
          <span className="review-section-icon">
            <Icon icon={icon} />
          </span>
          <h3>{title}</h3>
        </div>
        <div className="review-section-actions">
          {complete && (
            <span className="review-badge">
              <Icon icon="checkmark" />
              Vollständig
            </span>
          )}
          {onEdit && (
            <button
              type="button"
              className="review-edit"
              onClick={onEdit}
            >
              Bearbeiten
            </button>
          )}
        </div>
      </header>
      <div className="review-section-grid">
        {children}
      </div>
    </section>
  );
};

export default ReviewSection;
